const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_BASE_URL) throw new Error('REACT_APP_BACKEND_URL is required');

const getEmbedMarkup = (documentHtml) => {
  const style = documentHtml.match(/<style>[\s\S]*?<\/style>/i)?.[0] || '';
  const body = documentHtml.match(/<body[^>]*>([\s\S]*?)<\/body>/i)?.[1] || documentHtml;
  const scripts = documentHtml.match(/<script>[\s\S]*?<\/script>/gi)?.join('\n') || '';
  return `<!-- TweePorter basic story embed: paste into a Custom HTML/Code block -->\n${style}\n<div class="tweeporter-story">${body.replace(/<script>[\s\S]*?<\/script>/gi, '')}</div>\n${scripts}`;
};

export const buildBasicHtmlEmbed = async (tweeCode) => {
  const response = await fetch(`${API_BASE_URL}/api/exports/basic-html`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ twee_code: tweeCode, layout_option: 'bottom', link_display: 'buttons', intro_mode: false, navigation_option: 'full', max_passage_length: 0, style_colors: {} }),
  });
  const result = await response.json().catch(() => null);
  if (!response.ok || !result?.html) throw new Error(result?.detail || result?.error || 'Could not create HTML export');
  return { html: getEmbedMarkup(result.html), title: result.story_title || 'tweeporter-story', remainingCredits: result.remaining_credits, passageCount: result.passage_count };
};

export const downloadBasicHtml = (html, title) => {
  const filename = `${title.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase() || 'tweeporter-story'}-embed.html`;
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};